<script>
  import Multiselect from 'vue-multiselect'
  import { throttle } from 'lodash-es'
  import gql from 'graphql-tag'
  import { isISBN } from '@/helpers/isbn'
  const findTitresByTitle = gql`
    query findTitresByTitle($title: String!, $limit: Int, $page: Int) {
      # titres: titres(attrs: {titre: $title}, limit: $limit, page: $page) {
      titres: search_titres(q: $title, limit: $limit, page: $page) {
        id
        titre
        livres {
          id
          ean13
        }
      }
    }
  `
  import searchItemBook from './search-item-book.vue'

  export default {
    name: 'naturalSearch',
    props: {
      value: {
        // default: () => [],
        // type: Array,
      },
      search: {
        // default: () => [],
        // type: Array,
      },
    },
    components: {
      Multiselect,
      searchItemBook,
    },
    data () {
      return {
        titres: [],
        loadingTitres: 0,
        searchQuery: '',
      }
    },
    apollo: {
      titres: {
        query: findTitresByTitle,
        loadingKey: 'loadingTitres',
        variables () {
          return {
            title: this.searchQuery,
            limit: 10,
            page: 1,
          }
        },
        // returnPartialData: true,
        // forceFetch: true,
        error () {
          // console.error('We\'ve got an error!', error);
        },
        skip () {
          return !(this.searchQuery || this.isISBN)
        },
        result (titres) {
          console.log(titres)
        // this.titres = titres
        // Let's update the local data
        // this.tags.push(data.tagAdded);
        },
      },
    },
    computed: {
      isLoading () {
        return !!this.loadingTitres
      },
      isISBN () {
        return isISBN(this.searchQuery)
      },
    },
    methods: {
      resetSearchQuery () { this.searchQuery = null; this.titres = [] },
      selectBook ({ livres }) {
        const livre = livres.length && livres[0]
        this.$emit('input', livre)
      },
      selectISBN () {
        this.$emit('input', { ean13: this.searchQuery })
      },
      updateSearchQuery: throttle(function updateSearchQuery (searchQuery) {
        this.searchQuery = searchQuery
        this.$emit('search', searchQuery)
      }, 600, { trailing: true }), // BUG : https://github.com/apollostack/apollo-client/issues/1112
    },
  }
</script>

<template lang="pug">

div.search-input
  //- ul
  //-   li(v-for="titre in titres", style="color: black") {{ titre.titre }}
  multiselect.multiselect(
    :options!="(!searchQuery || isISBN) ? [] : titres",
    :internal-search="false",
    :loading="isLoading",
    :allow-empty="true",
    :close-on-select="true",
    id="ajax",
    label="titre",
    track-by="id",
    placeholder="Rechercher un livre"
    @search-change="updateSearchQuery",
    @select="selectBook"
    @close="resetSearchQuery",
    :block-keys="['Tab', 'Enter']"
  )
    template(slot="noResult", scope="props")
      button(type="button", class="button", v-if="isISBN", @mousedown.stop="selectISBN") Chercher par ce ISBN
      span(v-else-if="isLoading") Robert cherche...
      span(v-else) Livre introuvable
    template(slot="option", scope="props")
      //- pre {{props.option.livres}}
      search-item-book.searchitembook(:class="{'-is-loading': isLoading}", :titre="props.option", :id="props.option.livres.length && props.option.livres[0].id")
</template>

<style lang="postcss" scoped>
  .search-input {
    font-family: 'Roboto Sans', sans-serif;
    background-color: white;
    padding: 20px;
    border-radius: 8px;
  }
</style>
<style lang="postcss">

  .search-input {
    & .searchitembook {
      &.-is-loading {
        opacity: .65;
      }
    }
    & .multiselect {
      & .multiselect__option--highlight {
        background-color: rgb(213,213,213);
        & .title {
          color: black;
        }
        &:after {
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// search-input.vue?7d5b0d2f